import React from 'react';

const ProgresMulti = ({ percentageGraded = 0, course }) => {
  const safePercentage =
    typeof percentageGraded === 'number' && percentageGraded >= 0 ? percentageGraded : 0;

  const displayLabel = safePercentage === 0 ? '--%' : `${safePercentage}%`;
  console.log('displayLabel', displayLabel);

  return (
    <div
      className={`progress-bar-multi ${safePercentage === 0 ? 'empty-border' : 'filled-border'}`}
    >
      <div
        className={`progress-fill ${safePercentage === 0 ? 'empty-value' : ''}`}
        style={{
          width: safePercentage === 0 ? '100%' : `${safePercentage}%`,
          backgroundColor: safePercentage === 0 ? 'transparent' : '#FEDEB3',
          transition: 'width 0.5s ease-in-out',
        }}
      >
        <span
          className={`progress-label ${
            safePercentage < 40 && safePercentage > 0 ? 'low-percentage' : ''
          }`}
        >
          {displayLabel}
        </span>
      </div>
    </div>
  );
};

export default ProgresMulti;
